import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { INSERT_UPDATE_JURY_QUERY_ACTION_TYPE, insertUpdateJuryQueryUrl, headers, user_id, jury_id, award_event_id, juryReviewApplicationListUrl, GET_JURY_REVIEW_APPLICATION_LIST_ACTION_TYPE, GET_JURY_APPLICATION_QUERY_ACTION_TYPE, getJuryApplicationQueryUrl, getJuryReviewScoringPatternUrl, GET_JURY_REVIEW_SCORING_PATTERN_ACTION_TYPE, insertUpdateJuryReviewScoringUrl, IU_JURY_REVIEW_SCORING_ACTION_TYPE } from "../../utils/constants";

export const juryReviewApplicationList_action =
    (round_id, award_event_profile_id, application_status_id) => async (dispatch) => {
        try {
            const mapdata = {
                user_id: sessionStorage.getItem('user_id'),
                jury_id: sessionStorage.getItem('jury_id'),
                award_event_id: sessionStorage.getItem('award_event_id'),
                round_id: round_id,
                award_event_profile_id: award_event_profile_id,
                application_status_id: application_status_id,
            };
            const params = {
                user_id: mapdata.user_id === "" ? null : mapdata.user_id,
                jury_id: mapdata.jury_id === "" ? null : mapdata.jury_id,
                award_event_id: mapdata.award_event_id === "" ? null : mapdata.award_event_id,
                round_id: mapdata.round_id === "" ? null : mapdata.round_id,
                award_event_profile_id: mapdata.award_event_profile_id === "" ? null : mapdata.award_event_profile_id,
                application_status_id: mapdata.application_status_id === "" ? null : mapdata.application_status_id,
            };
            const res = await axiosGet(juryReviewApplicationListUrl, params, headers);
            dispatch({
                type: GET_JURY_REVIEW_APPLICATION_LIST_ACTION_TYPE,
                payload: res,
            });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const juryApplicationQuery_action =
    (application_form_id) => async (dispatch) => {
        try {
            const mapdata = {
                user_id: sessionStorage.getItem('user_id'),
                application_form_id: application_form_id
            };
            const params = {
                user_id: mapdata.user_id === "" ? null : mapdata.user_id,
                application_form_id: mapdata.application_form_id === "" ? null : mapdata.application_form_id
            };
            const res = await axiosGet(getJuryApplicationQueryUrl, params, headers);
            dispatch({
                type: GET_JURY_APPLICATION_QUERY_ACTION_TYPE,
                payload: res,
            });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const insertUpdateJuryQuery_action =
    (jury_application_form_query_id, application_form_id, qry_ans_by_id, qry_answer, qry_ans_date, callback_query, callback_date, callback_time) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    jury_application_form_query_id: jury_application_form_query_id != '' ? jury_application_form_query_id : 0,
                    application_form_id: application_form_id != '' ? application_form_id : '',
                    qry_ans_by_id: qry_ans_by_id != '' ? qry_ans_by_id : 0,
                    qry_answer: qry_answer != '' ? qry_answer : null,
                    qry_ans_date: qry_ans_date != '' ? qry_ans_date : null,
                    callback_query: callback_query != '' ? callback_query : '',
                    callback_date: callback_date != '' ? callback_date : '',
                    callback_time: callback_time != '' ? callback_time : '',
                };
                const res = await axiosPost(insertUpdateJuryQueryUrl, mapdata, headers);
                dispatch({
                    type: INSERT_UPDATE_JURY_QUERY_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };
export const juryReviewScoringPattern_action =
    (award_event_profile_id, application_form_id) => async (dispatch) => {
        try {
            const mapdata = {
                user_id: sessionStorage.getItem('user_id'),
                jury_id: sessionStorage.getItem('jury_id'),
                award_event_id: sessionStorage.getItem('award_event_id'),
                award_event_profile_id: award_event_profile_id,
                application_form_id: application_form_id,
            };
            const params = {
                user_id: mapdata.user_id === "" ? null : mapdata.user_id,
                jury_id: mapdata.jury_id === "" ? null : mapdata.jury_id,
                award_event_id: mapdata.award_event_id === "" ? null : mapdata.award_event_id,
                award_event_profile_id: mapdata.award_event_profile_id === "" ? null : mapdata.award_event_profile_id,
                application_form_id: mapdata.application_form_id === "" ? null : mapdata.application_form_id,
            };
            const res = await axiosGet(getJuryReviewScoringPatternUrl, params, headers);
            dispatch({
                type: GET_JURY_REVIEW_SCORING_PATTERN_ACTION_TYPE,
                payload: res,
            });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    };
export const insertUpdateJuryReviewScoring_action =
    (application_status_id, jury_id, award_event_profile_id, scoringData) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    application_status_id: application_status_id,
                    jury_id: jury_id,
                    award_event_profile_id: award_event_profile_id,
                    scoringData: scoringData
                };
                const res = await axiosPost(insertUpdateJuryReviewScoringUrl, mapdata, headers);
                dispatch({
                    type: IU_JURY_REVIEW_SCORING_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };